import { useQuery } from '@tanstack/react-query';
import { personInternalApi } from '../apis';
import { useMe } from '../organisation/useMe';
import { CAN_READ_PERSON } from '../auth/permissions';

export const useCheckIfPersonsExist = () => {
  const { permissions } = useMe();

  return useQuery({
    enabled: permissions.includes(CAN_READ_PERSON),
    queryKey: ['checkIfPersonsExist'],
    queryFn: async () => {
      const response = await personInternalApi.checkIfPersonsExist();
      return (response as unknown as string) === 'true';
    },
    staleTime: Infinity,
  });
};
